export function getDate(state) {
    return state.date
}

export function getType(state) {
    return state.type_id
}

export function getStaffs(state) {
    return state.staffs
}
export function getScheduleId(state) {
    return state.scheduleId
}

export function getSchedulePO(state) {
    return state.schedulePO
}


export function confirmTechnician(state) {
    return state.confirm_technician
}
export function confirmClient(state) {
    return state.confirm_client
}

export function existRWT(state) {
    return state.rwt
}

function convertTimeToMinutes(time) {
    if (!time) return null; // Verifica se a hora é nula
    const [hours, minutes] = time.split(":").map(Number);
    return (hours * 60) + minutes;
}

function calculateTotalHours(arr) {
    let totalMinutes = 0;

    arr.forEach(obj => {
        obj.dates.forEach(date => {
            const start = convertTimeToMinutes(date.start_hour);
            const end = convertTimeToMinutes(date.end_hour);

            if (start !== null && end !== null && date.absent === 0) {
                totalMinutes += (end - start);
            } else {
                totalMinutes += 0;
            }
        });
    });

    const totalHours = totalMinutes / 60;
    return totalHours;
}

export function totalHours(state) {
    return calculateTotalHours(state.datesHours)
}







